import { downloadFile } from '@faceup/utils'
import { ok } from 'neverthrow'
import { decryptFileWithReportKey, type FileDescriptor, loadFile } from './files'
import { readReportKey } from './report'
import { mapErr } from './utils/general'

export const loadFileWithReportKey = async (
  { url, name, mimetype }: FileDescriptor,
  recipientKey: string
) => {
  const loadedFile = await loadFile({ url, name, mimetype })
  if (loadedFile.isErr()) {
    return mapErr(loadedFile, '[loadFileWithReportKey]: Could not load file')
  }
  const file = loadedFile.value

  const reportKey = await readReportKey(recipientKey)
  if (reportKey.isErr()) {
    return mapErr(reportKey, '[loadFileWithReportKey]: Could not read report key when loading file')
  }

  const decryptedFile = await decryptFileWithReportKey(file, reportKey.value)
  if (decryptedFile.isErr()) {
    return mapErr(decryptedFile, '[loadFileWithReportKey]: Could not decrypt file with report key')
  }

  return ok(decryptedFile.value)
}

export const downloadFileWithReportKey = async (
  file: FileDescriptor,
  recipientKey: string,
  // Define this function if standard download using `.click()` on created element is not available (e.g. mobile app)
  download: (blob: Blob, name: string) => void = downloadFile
) => {
  const decryptedFile = await loadFileWithReportKey(file, recipientKey)
  if (decryptedFile.isErr()) {
    return mapErr(
      decryptedFile,
      '[downloadFileWithReportKey]: Could not download file with report key'
    )
  }

  return ok(download(decryptedFile.value, file.name))
}
